export default __webpack_public_path__ + "static/media/feature3.24328cb8.png";